import React from 'react';
import { mockLogs } from '../../Data/Dummydata';
import PriceLogTable from '../../Pages/Seller/PriceLogTable';

const SellerPriceLog = () => {
  return (
    <div className="max-w-6xl mx-auto py-6">
      <PriceLogTable logs={mockLogs} />
    </div>
  );
};

export default SellerPriceLog;
